import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CoNovelistComponent } from './co-novelist/co-novelist';

import { CoReserveRoomDetailsComponent } from './co-reserve-room-details/co-reserve-room-details';
import { CoEventTypesPillComponent } from './co-event-types-pill/co-event-types-pill';

import { CoEventCheckInComponent } from './co-event-check-in/co-event-check-in';

import { CoEventsExploreCardComponent } from './co-events-explore-card/co-events-explore-card';

import { CoEventRegisterCustomQuestionComponent } from './co-event-register-custom-question/co-event-register-custom-question';
import { CoListComponent } from './co-list/co-list';
import { CoEventCardRegistrationStatusComponent } from './co-event-card-registration-status/co-event-card-registration-status';
import { CoOnlineResourcesWidgetComponent } from './co-online-resources-widget/co-online-resources-widget';



import { CoClockComponent } from './co-clock/co-clock';
import { CoDateComponent } from './co-date/co-date';
import { CoFacebookComponent } from './co-facebook/co-facebook';
import { CoTwitterFeedComponent } from './co-twitter-feed/co-twitter-feed';
import { CoNewsComponent } from './co-news/co-news';
import { CoCheckoutComponent } from './co-checkout/co-checkout';
import { CoPatronLookupComponent } from './co-patron-lookup/co-patron-lookup';
import { CoInstagramComponent } from './co-instagram/co-instagram';

import { CoCatalogSearchComponent } from './co-catalog-search/co-catalog-search';
import { CoBibSummaryComponent } from './co-bib-summary/co-bib-summary';
import { CoLoggedInIconComponent } from './co-logged-in-icon/co-logged-in-icon';
import { CoStaffLogoutComponent } from './co-staff-logout/co-staff-logout';


import { CoHomeNavButtonComponent } from './co-home-nav-button/co-home-nav-button';


import { CoReserveAccountCardComponent } from './co-reserve-account-card/co-reserve-account-card';
import { CoBibCoverComponent } from './co-bib-cover/co-bib-cover';
import { CoFooterBlockComponent } from './co-footer-block/co-footer-block';

import { CoSelfcheckHeaderComponent } from './co-selfcheck-header/co-selfcheck-header';
import { CoDigitalItemComponent } from './co-digital-item/co-digital-item';
import { CoDigitalSummaryComponent } from './co-digital-summary/co-digital-summary';
import { CoEventCategoryFilteringComponent } from './co-event-category-filtering/co-event-category-filtering';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { Ionic2RatingModule } from 'ionic2-rating';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { CoReserveTimelineComponent } from './co-reserve-timeline/co-reserve-timeline';
import { CoBibItemComponent } from './co-bib-item/co-bib-item';


import { CoButtonComponent } from './co-button/co-button';
import { CoDensitySwitchComponent } from './co-density-switch/co-density-switch';
import { CoLocationComponent } from './co-location/co-location';
import { CoLocationsComponent } from './co-locations/co-locations';

import { CoLocationImageComponent } from './co-location-image/co-location-image';
import { CoLocationHoursComponent } from './co-location-hours/co-location-hours';
import { CoLocationModularComponent } from './co-location-modular/co-location-modular';
import { CoDiscoverComponent } from './co-discover/co-discover';
import { CoDiscoverExploreComponent } from './co-discover-explore/co-discover-explore';
import { CoDiscoverItemComponent } from './co-discover-item/co-discover-item';
import { CoDiscoverLaneComponent } from './co-discover-lane/co-discover-lane';
import { CoEventRegistrantlistComponent } from './co-event-registrantlist/co-event-registrantlist';
import { CoEventDesktopFilterSidebarComponent } from './co-event-desktop-filter-sidebar/co-event-desktop-filter-sidebar';
import { CoEventsExploreComponent } from './co-events-explore/co-events-explore';
import { CoEventsDayComponent } from './co-events-day/co-events-day';
import { CoEventsWeekComponent } from './co-events-week/co-events-week';

import { CoEventsMonthComponent } from './co-events-month/co-events-month';


import { CoEventDetailsComponent } from './co-event-details/co-event-details';
import { CoEventsExploreDesktopComponent } from './co-events-explore-desktop/co-events-explore-desktop';
import { CoEventsFeaturedCardComponent } from './co-events-featured-card/co-events-featured-card';
import { CoEventsMonthDesktopComponent } from './co-events-month-desktop/co-events-month-desktop';
import { CoEventsMonthDropdownComponent } from './co-events-month-dropdown/co-events-month-dropdown';
import { CoEventsRangeComponent } from './co-events-range/co-events-range';
import { CoExploreEventsBlockComponent } from './co-explore-events-block/co-explore-events-block';
import { CoHtmlComponent } from './co-html/co-html';
import { CoMapComponent } from './co-map/co-map';
import { CoNumberpadComponent } from './co-numberpad/co-numberpad';
import { CoPagesComponent } from './co-pages/co-pages';


import { CoReservationDetailsComponent } from './co-reservation-details/co-reservation-details';

import { CoReserveRoomCardComponent } from './co-reserve-room-card/co-reserve-room-card';
import { CoRoamEventlistComponent } from './co-roam-eventlist/co-roam-eventlist';
import { CoRoamSecurityComponent } from './co-roam-security/co-roam-security';
import { CoRoomTimelineDetailsComponent } from './co-room-timeline-details/co-room-timeline-details';
import { CoWeekCalendarViewComponent } from './co-week-calendar-view/co-week-calendar-view';
import { CoWidgetComponent } from './co-widget/co-widget';
import { CoReserveDesktopFilterSidebarComponent } from './co-reserve-desktop-filter-sidebar/co-reserve-desktop-filter-sidebar';
import { CoReserveComponent } from './co-reserve/co-reserve';
import { CoAttendComponent } from './co-attend/co-attend';
import { CoAttendEventCardComponent } from './co-attend-event-card/co-attend-event-card';
import { CoScreenRowComponent } from './co-screen-row/co-screen-row';
import { CoScreenColComponent } from './co-screen-col/co-screen-col';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { AgmCoreModule } from '@agm/core';
import { CoRecommendedReadsWidgetComponent } from './co-recommended-reads-widget/co-recommended-reads-widget';
import { CoPatronDetailComponent } from './co-patron-detail/co-patron-detail';
import { CoBlockComponent } from './co-block/co-block';
import { CoRecentAccountsComponent } from './co-recent-accounts/co-recent-accounts';
import { CoSelfcheckHeaderAccountButtonComponent } from './co-selfcheck-header-account-button/co-selfcheck-header-account-button';
import { NgxBarcodeModule } from 'ngx-barcode';
import { CoReserveReservationsComponent } from './co-reserve-reservations/co-reserve-reservations';
import { CoPopoverStaffSignOutComponent } from './co-popover-staff-sign-out/co-popover-staff-sign-out';
import { CoStaffPinComponent } from './co-staff-pin/co-staff-pin';
import { CoPickerComponent } from './co-picker/co-picker.component';
import { CoCalendarComponent } from './co-calendar/co-calendar';
import { CoActivePatronComponent } from './co-active-patron/co-active-patron';

@NgModule({
    declarations: [CoNovelistComponent,
        CoReserveRoomDetailsComponent,

        CoPickerComponent,
        CoEventTypesPillComponent,

        CoEventCheckInComponent,

        CoEventsExploreCardComponent,

        CoEventRegisterCustomQuestionComponent,
        CoListComponent,
        CoEventCardRegistrationStatusComponent,
        CoOnlineResourcesWidgetComponent,


        CoRecommendedReadsWidgetComponent,
        CoFacebookComponent,
        CoTwitterFeedComponent,
        CoClockComponent,
        CoDateComponent,
        CoNewsComponent,
        CoCheckoutComponent,
        CoPatronLookupComponent,
        CoInstagramComponent,

        CoCatalogSearchComponent,
        CoBibSummaryComponent,
        CoLoggedInIconComponent,
        CoStaffLogoutComponent,


        CoHomeNavButtonComponent,


        CoReserveAccountCardComponent,
        CoBibCoverComponent,
        CoFooterBlockComponent,

        CoSelfcheckHeaderComponent,
        CoDigitalItemComponent,
        CoDigitalSummaryComponent,
        CoEventCategoryFilteringComponent,
        CoReserveTimelineComponent,
        CoBibItemComponent,


        CoButtonComponent,
        CoDensitySwitchComponent,
        CoButtonComponent,

        CoLocationComponent,
        CoLocationsComponent,

        CoLocationImageComponent,
        CoLocationHoursComponent,
        CoLocationModularComponent,
        CoDiscoverComponent,
        CoDiscoverExploreComponent,
        CoDiscoverItemComponent,
        CoDiscoverLaneComponent,
        CoEventRegistrantlistComponent,
        CoEventDesktopFilterSidebarComponent,
        CoEventsExploreComponent,
        CoEventsDayComponent,
        CoEventsWeekComponent,

        CoEventsMonthComponent,


        CoEventDetailsComponent,
        CoEventsDayComponent,
        CoEventsExploreComponent,
        CoEventsExploreDesktopComponent,
        CoEventsFeaturedCardComponent,
        CoEventsMonthComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventsRangeComponent,
        CoEventsWeekComponent,
        CoExploreEventsBlockComponent,
        CoHtmlComponent,
        CoLocationComponent,
        CoLocationHoursComponent,
        CoLocationImageComponent,
        CoLocationModularComponent,
        CoLocationsComponent,
        CoMapComponent,
        CoNumberpadComponent,
        CoPagesComponent,

        CoPatronDetailComponent,
        CoBlockComponent,
        CoReservationDetailsComponent,

        CoReserveRoomCardComponent,
        CoReserveTimelineComponent,
        CoRoamEventlistComponent,
        CoRoamSecurityComponent,
        CoRoomTimelineDetailsComponent,
        CoWeekCalendarViewComponent,
        CoWidgetComponent,
        CoEventsExploreDesktopComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventDesktopFilterSidebarComponent,
        CoReserveDesktopFilterSidebarComponent,
        CoReserveComponent,
        CoAttendComponent,
        CoAttendEventCardComponent,
        CoCalendarComponent,
        CoScreenRowComponent,
        CoScreenColComponent,
    CoSelfcheckHeaderAccountButtonComponent,
    CoRecentAccountsComponent,
    CoReserveReservationsComponent,
    CoStaffPinComponent,
    CoActivePatronComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        Ionic2RatingModule,
        DirectivesModule,
        PipesModule,
        ShareButtonsModule,
        LazyLoadImageModule,
        VirtualScrollerModule,
        AgmSnazzyInfoWindowModule,
        AgmCoreModule,
        NgxBarcodeModule
    ],
    exports: [CoNovelistComponent,
        CoReserveRoomDetailsComponent,

        CoEventTypesPillComponent,

        CoEventCheckInComponent,

        CoEventsExploreCardComponent,
        CoRecommendedReadsWidgetComponent,
        CoEventRegisterCustomQuestionComponent,
        CoListComponent,
        CoEventCardRegistrationStatusComponent,
        CoOnlineResourcesWidgetComponent,

        CoPatronDetailComponent,

        CoFacebookComponent,
        CoTwitterFeedComponent,
        CoClockComponent,
        CoDateComponent,
        CoNewsComponent,
        CoCheckoutComponent,
        CoPatronLookupComponent,
        CoInstagramComponent,

        CoCatalogSearchComponent,
        CoBibSummaryComponent,
        CoLoggedInIconComponent,
        CoStaffLogoutComponent,


        CoHomeNavButtonComponent,


        CoReserveAccountCardComponent,
        CoBibCoverComponent,
        CoFooterBlockComponent,

        CoSelfcheckHeaderComponent,
        CoDigitalItemComponent,
        CoDigitalSummaryComponent,
        CoEventCategoryFilteringComponent,
        CoReserveTimelineComponent,
        CoBibItemComponent,


        CoButtonComponent,
        CoDensitySwitchComponent,
        CoButtonComponent,

        CoLocationComponent,
        CoLocationsComponent,

        CoLocationImageComponent,
        CoLocationHoursComponent,
        CoLocationModularComponent,
        CoDiscoverComponent,
        CoDiscoverExploreComponent,
        CoDiscoverItemComponent,
        CoDiscoverLaneComponent,
        CoEventRegistrantlistComponent,
        CoEventDesktopFilterSidebarComponent,
        CoEventsExploreComponent,
        CoEventsDayComponent,
        CoEventsWeekComponent,

        CoEventsMonthComponent,


        CoEventDetailsComponent,
        CoEventsDayComponent,
        CoEventsExploreComponent,
        CoEventsExploreDesktopComponent,
        CoEventsFeaturedCardComponent,
        CoEventsMonthComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventsRangeComponent,
        CoEventsWeekComponent,
        CoExploreEventsBlockComponent,
        CoHtmlComponent,
        CoLocationComponent,
        CoLocationHoursComponent,
        CoLocationImageComponent,
        CoLocationModularComponent,
        CoLocationsComponent,
        CoMapComponent,
        CoNumberpadComponent,
        CoPagesComponent,
        CoBlockComponent,


        CoReservationDetailsComponent,

        CoReserveRoomCardComponent,
        CoReserveTimelineComponent,
        CoRoamEventlistComponent,
        CoRoamSecurityComponent,
        CoRoomTimelineDetailsComponent,
        CoWeekCalendarViewComponent,
        CoWidgetComponent,
        CoEventsExploreDesktopComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventDesktopFilterSidebarComponent,
        CoReserveDesktopFilterSidebarComponent,
        CoReserveComponent,
        CoAttendComponent,
        CoAttendEventCardComponent,
        CoCalendarComponent,
        CoScreenRowComponent,
        CoScreenColComponent,
    CoSelfcheckHeaderAccountButtonComponent,
    CoRecentAccountsComponent,
    CoReserveReservationsComponent,
    CoStaffPinComponent,
    CoReserveReservationsComponent,
    CoActivePatronComponent
    ],
    entryComponents: [
        CoNovelistComponent,
        CoReserveRoomDetailsComponent,
        CoPickerComponent,
        CoEventTypesPillComponent,

        CoEventCheckInComponent,

        CoEventsExploreCardComponent,
        CoRecommendedReadsWidgetComponent,
        CoEventRegisterCustomQuestionComponent,
        CoListComponent,
        CoEventCardRegistrationStatusComponent,
        CoOnlineResourcesWidgetComponent,

        CoPatronDetailComponent,

        CoFacebookComponent,
        CoTwitterFeedComponent,
        CoClockComponent,
        CoDateComponent,
        CoNewsComponent,
        CoCheckoutComponent,
        CoPatronLookupComponent,
        CoInstagramComponent,

        CoCatalogSearchComponent,
        CoBibSummaryComponent,
        CoLoggedInIconComponent,
        CoStaffLogoutComponent,


        CoHomeNavButtonComponent,


        CoReserveAccountCardComponent,

        CoBlockComponent,
        CoBibCoverComponent,
        CoFooterBlockComponent,

        CoSelfcheckHeaderComponent,
        CoDigitalItemComponent,
        CoDigitalSummaryComponent,
        CoEventCategoryFilteringComponent,
        CoReserveTimelineComponent,
        CoBibItemComponent,


        CoButtonComponent,
        CoDensitySwitchComponent,
        CoButtonComponent,

        CoLocationComponent,
        CoLocationsComponent,

        CoLocationImageComponent,
        CoLocationHoursComponent,
        CoLocationModularComponent,
        CoDiscoverComponent,
        CoDiscoverExploreComponent,
        CoDiscoverItemComponent,
        CoDiscoverLaneComponent,
        CoEventRegistrantlistComponent,
        CoEventDesktopFilterSidebarComponent,
        CoEventsExploreComponent,
        CoEventsDayComponent,
        CoEventsWeekComponent,

        CoEventsMonthComponent,


        CoEventDetailsComponent,
        CoEventsDayComponent,
        CoEventsExploreComponent,
        CoEventsExploreDesktopComponent,
        CoEventsFeaturedCardComponent,
        CoEventsMonthComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventsRangeComponent,
        CoEventsWeekComponent,
        CoExploreEventsBlockComponent,
        CoHtmlComponent,
        CoLocationComponent,
        CoLocationHoursComponent,
        CoLocationImageComponent,
        CoLocationModularComponent,
        CoLocationsComponent,
        CoMapComponent,
        CoNumberpadComponent,
        CoPagesComponent,



        CoReservationDetailsComponent,

        CoReserveRoomCardComponent,
        CoReserveTimelineComponent,
        CoRoamEventlistComponent,
        CoRoamSecurityComponent,
        CoRoomTimelineDetailsComponent,
        CoWeekCalendarViewComponent,
        CoWidgetComponent,
        CoEventsExploreDesktopComponent,
        CoEventsMonthDesktopComponent,
        CoEventsMonthDropdownComponent,
        CoEventDesktopFilterSidebarComponent,
        CoReserveDesktopFilterSidebarComponent,
        CoReserveComponent,
        CoAttendComponent,
        CoAttendEventCardComponent,
        CoCalendarComponent,
        CoScreenRowComponent,
        CoScreenColComponent,
        CoPopoverStaffSignOutComponent,
        CoActivePatronComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts